module.exports = __webpack_public_path__ + "img/lecture_offline2.dfad4ee3.png";